module.exports = __webpack_public_path__ + "static/media/app-bienvenue.df69b319.glb";